var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableRender',{attrs:{"show-filter-text":"","config":_vm.config,"show-export":false,"endpoint":"/agencies","table-title":"Orgãos Emissores","label-btn-add":_vm.isAdmin ? 'Cadastrar' : null},on:{"on-click-add":_vm.onClickAdd}})
}
var staticRenderFns = []

export { render, staticRenderFns }